module.exports = __webpack_public_path__ + "img/scb.d9fab6a5.jpg";